<template>
  <div class="kong-box">
  	<div class="kong">
  		<img src="../../assets/image/kong.png" alt=""/>
  		<span>{{$t('all.zanwushuju')}}</span>
  	</div>
  </div>
</template>

<script>
export default {
  name:'kong',
  data() {
    return {
	  
    };
  },
  mounted() {
	
  },
  methods: {
	

  }
};
</script>
<style scoped lang="scss">
	.kong-box{
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		width: 100%;
		height: calc(100% - 120px) ;
	}
	.kong{
		display: flex;
		flex-direction: column;
		align-items: center;
	}
	.kong img{
		width: 200px;
	}
	.kong span{
		padding-top: 30px;
		font-family: MiSans, MiSans;
		font-weight: 400;
		font-size: 16px;
		color: #FFFFFF;
		text-align: center;
	}
</style>


// WEBPACK FOOTER //
// kong.vue?02b3028e